import * as React from "react";

function ChevronsRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m233.3 239.4-176-184c-9.11-9.56-24.3-9.91-33.89-.75C18.47 59.37 16 65.68 16 71.99c0 5.969 2.219 11.94 6.656 16.59L182.8 256 22.7 423.4c-9.125 9.594-8.844 24.78.75 33.94 9.594 9.156 24.78 8.813 33.94-.75l176-184c8.81-9.29 8.81-23.89-.09-33.19zm192 0-176-184c-9.1-9.56-24.3-9.91-33.9-.75-4.9 4.72-7.4 11.03-7.4 17.34 0 5.969 2.219 11.94 6.656 16.59L374.8 256 214.7 423.4c-9.125 9.594-8.844 24.78.75 33.94 9.594 9.156 24.78 8.813 33.94-.75l176-184c8.81-9.29 8.81-23.89-.09-33.19z"
  }));
}

const ForwardRef = React.forwardRef(ChevronsRightIcon);
export default ForwardRef;